import { render, staticRenderFns } from "./modularChild7.vue?vue&type=template&id=2a167b06&scoped=true"
import script from "./modularChild7.vue?vue&type=script&lang=js"
export * from "./modularChild7.vue?vue&type=script&lang=js"
import style0 from "./modularChild7.vue?vue&type=style&index=0&id=2a167b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a167b06",
  null
  
)

export default component.exports